import { Button, Flex, FormControl, FormLabel, Input, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { ChangeEventHandler, FormEventHandler, useEffect, useState } from 'react';
import { unitAssessmentState } from '../../UnitAssessmentState';
import { useSnapshot } from 'valtio';
import { trpcAdmin } from '../../../lib/trpcAdmin';
import { LinkedRequirementsSection } from '../LinkedRequirementsSection';

export function QuestionGroupEditor({ refetch }: { refetch: () => void }) {
  const unitAssessmentSnap = useSnapshot(unitAssessmentState);
  const [formData, setFormData] = useState({
    title: '',
  });

  useEffect(() => {
    setFormData({
      title: unitAssessmentSnap.currentSlide?.title || '',
    });
  }, [unitAssessmentSnap.currentSlide, unitAssessmentSnap.isEditorOpen]);

  const updateQuestionGroup = trpcAdmin.unitAssessment.updateQuestionGroup.useMutation({
    onSuccess: () => {
      unitAssessmentState.closeEditor();
      unitAssessmentState.setHasUnpublishedChanges(true);
      refetch();
    },
  });

  const onFormChange: ChangeEventHandler<any> = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const onFormSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();

    if (unitAssessmentSnap.currentSlide) {
      await updateQuestionGroup.mutateAsync({
        id: unitAssessmentSnap.currentSlide.id,
        title: formData.title,
        position: unitAssessmentSnap.currentSlide.position,
      });
      return;
    }
  };

  return (
    <form onSubmit={onFormSubmit} style={{ width: '100%' }}>
      <VStack spacing={4} align="stretch">
        <FormControl isRequired>
          <FormLabel>
            <Trans>Slide Title</Trans>
          </FormLabel>
          <Input
            autoFocus
            type="text"
            autoComplete="Off"
            placeholder="Title"
            name="title"
            value={formData.title}
            onChange={onFormChange}
          />
        </FormControl>

        <LinkedRequirementsSection />

        <Flex justify={'flex-end'}>
          <Button right={0} type="submit">
            <Trans>Update</Trans>
          </Button>
        </Flex>
      </VStack>
    </form>
  );
}
